import { useEffect, useState } from 'react';
import { useDesignsContext } from '@/shared/providers/DesignsProvider';
import checkIsSupporter from '@/shared/utils/checkIsSupporter';
import useAuthStore from '@pkg/auth/useStore';

const useIsSupporter = (entityId) => {
  const { me } = useAuthStore();
  const { supporterMap } = useDesignsContext();

  const [isSupporter, setIsSupporter] = useState(null);

  useEffect(() => {
    if (!entityId || !supporterMap?.size || !me) {
      return;
    }

    setIsSupporter(checkIsSupporter(entityId, me.id, supporterMap));
  }, [entityId, supporterMap]);

  return isSupporter;
};

export default useIsSupporter;
